import { WishlistService } from './../wishlist.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { TopsellerService } from "../topseller.service";
import { Global } from "../classes/Global";
import { BlogService } from "../blog.service";
import { InfoService } from "../info.service";
import { Router, ActivatedRoute } from "@angular/router";
import { StorageHelper } from '../helpers/StorageHelper';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { Log } from '../helpers/Log';
import { AuthenticationService } from '../authentication.service';
import { LoginHelper } from '../helpers/LoginHelper';
import { ThemeService } from '../theme.service';
import { StringHelper } from '../helpers/StringHelper';
import { CountryService } from '../country.service';
import { ICountryChangedListener } from '../classes/ICountryChangedListener';
import { Config } from '../classes/Config';
import * as moment from 'moment';
import { BlocklistService } from '../blocklist.service';
import { OwnListService } from '../own-list.service';
import { ListHelper } from '../helpers/ListHelper';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [ TopsellerService, BlogService, InfoService, AuthenticationService, WishlistService, OwnListService, ThemeService ]
})
export class HomeComponent extends BaseComponent implements OnInit, ICountryChangedListener {

  itemsItunes: Array<any>;
  itemsAmazon: Array<any>;
  itemsGooglePlay: Array<any>;
  itemsVudu: Array<any>;
  blogPosts: Array<any>;
  searchItemTypes: Array<string> = [];
  @ViewChild("header", {static: false}) header;
  @ViewChild("notificationSettingsModal", {static: false}) notificationSettingsModal;

  token = "";
  showSettings = false;
  todayDate: string;
  searchSelectedItemType: string;

  constructor(
    private topsellerService: TopsellerService,
    private blogService: BlogService,
    private router: Router,
    private infoService: InfoService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private wishlistService: WishlistService,
    private ownlistService: OwnListService,
    private blocklistService: BlocklistService,
    private themeService: ThemeService,
    private countryService: CountryService
  ) {
    super();
    this.searchItemTypes = Global.mediaTypesForSearch[Global.getStore()];
    this.searchSelectedItemType = "all";
    //If the new store does not have the currenty selected one, pick the first available
    if (this.searchItemTypes && this.searchItemTypes.indexOf(this.searchSelectedItemType) === -1) {
      this.searchSelectedItemType = this.searchItemTypes[0];
    }
    this.countryService.countryChangedListeners = [];
    this.countryService.addEventListener(this);
  }

  onCountryChanged(country: any) {
    this.countryService.countryChangedListeners = [];
    //change the store to itunes if the newly selected country doesn't support the current store
    Global.ensureStoreIsSupported();
    this.getShortWishList();
    this.getShortOwnList();
    this.getShortBlockList();
    this.setHomePageSubtitle1();
    this.reload();
  }

  onCountryAndTokenDone() {
    if (this.token) {
      this.infoService.getUserDataBySessionToken(this.token,
        StorageHelper.getInstance().get(StorageHelper.keys.country)).subscribe(result => {

          if (result && result["status"] == "success") {
            StorageHelper.getInstance().save(StorageHelper.keys.sessionToken, this.token);
            StorageHelper.getInstance().save(StorageHelper.keys.username, result['username']);
            StorageHelper.getInstance().save(StorageHelper.keys.email, result['mail']);
            StorageHelper.getInstance().save(StorageHelper.keys.profileImageUrl, result['profileImage']);
            StorageHelper.getInstance().save(StorageHelper.keys.uniqueCustomerId, result['uniqueCustomerId']);
            this.authenticationService.setIsLoggedIn(true);
            LoginHelper.getInstance().loginChanged(true);
            this.reload();

            if (this.showSettings) {
              this.notificationSettingsModal.open();
            }
          }
          else {
            Global.clearSaveUserInfos();
            this.authenticationService.setIsLoggedIn(false);
            LoginHelper.getInstance().loginChanged(false);
          }

      }, err => {
        Global.clearSaveUserInfos();
        this.authenticationService.setIsLoggedIn(false);
        LoginHelper.getInstance().loginChanged(false);
        Log.getInstance().d(err);
      });
    }
  }

  ngOnInit() {

    this.todayDate = this.getTodayDate();

    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get("sessionToken");
      this.showSettings = params.get("showSettings") == "1";

      this.onCountryAndTokenDone();

    });

    this.setHomePageSubtitle1();

  }

  isDarkTheme(): boolean {
    return this.themeService.isDarkTheme();
  }

  getShortWishList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken){
      this.wishlistService.getShortWishlist(
        Global.getCountry(),
        store,
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[store] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
          if (saved) {
            ListHelper.clearWishlistCache();
          } else {
            Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
          }
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortOwnList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken){
      this.ownlistService.getShortItemList(
        sessionToken,
        store,
        Global.getCountry()
      ).subscribe(res => {
        if (res && res['results']) {
          const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist) || {};
          shortOwnlist[store] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortOwnlist, shortOwnlist);
          if (saved) {
            ListHelper.clearOwnlistCache();
          } else {
            Log.getInstance().d('Failed to save ownlist to storage - storage may be full');
          }
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortBlockList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken){
      this.blocklistService.getShortBlocklist(
        Global.getCountry(),
        store,
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist) || {};
          shortBlocklist[store] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortBlocklist, shortBlocklist);
          if (saved) {
            ListHelper.clearBlocklistCache();
          } else {
            Log.getInstance().d('Failed to save blocklist to storage - storage may be full');
          }
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  addToWishlist(item, store: string) {
    const id = item.idInStore || item.itemID;
    const ignoreSdPrice = this.shouldIgnoreSdPriceForMediaType(Global.getMediaType());
    this.wishlistService.addItem(Global.getCountry(), store, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id, ignoreSdPrice).subscribe(res => {
      this.getShortWishList(store);
    }, err => {

    });
  }

  /**
   * Checks if SD price should be ignored when adding to wishlist.
   * Only applies to movies and TV seasons.
   */
  private shouldIgnoreSdPriceForMediaType(mediaType: string): boolean {
    const setting = StorageHelper.getInstance().get(StorageHelper.keys.ignoreSdPriceOnWishlist);
    // Default is true - only return false if explicitly set to false
    if (setting === false) {
      return false;
    }
    // Only apply to movies and TV seasons
    // Note: 'seasons' is the plural of 'season' itemType, 'tvSeasons' is the plural of 'tvSeason' itemType
    const movieAndTvTypes = ['movies', 'buyMovies', 'rentalMovies', 'seasons', 'tvSeasons'];
    return movieAndTvTypes.indexOf(mediaType) !== -1;
  }

  addToOwnlist(item, store: string) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.addItem(Global.getCountry(), store, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnList(store);
    }, err => {

    });
  }

  addToBlocklist(item, store: string) {
    const id = item.idInStore || item.itemID;
    this.blocklistService.addItem(Global.getCountry(), store, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortBlockList(store);
    }, err => {

    });
  }

  removeFromWishlist(item, store: string) {
    const id = item.idInStore || item.itemID;
    this.wishlistService.removeItem(Global.getCountry(), store, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortWishList(store);
    }, err => {

    });
  }

  removeFromOwnlist(item, store: string) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.removeItem(Global.getCountry(), store, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnList(store);
    }, err => {

    });
  }

  reload() {
    this.loadTopsellers();
  }

  loadTopsellers(){
    let country = this.countryService.getCountry();
     this.topsellerService.getTopSellersForStartPage(country, 5).subscribe(res => {
      if (res && res["results"]) {
        this.itemsItunes = res["results"]["itunes"];
        this.itemsGooglePlay = res["results"]["googlePlay"];
        this.itemsAmazon = res["results"]["amazon"];
        this.itemsVudu = res["results"]["vudu"];
      }
    }, err => {
      Log.getInstance().d(err);
    });
  }

  loadBlogPosts(){
    this.blogService.getBlogPosts(Global.getCountry()).subscribe(res => {
      if (res && res["results"]){
        this.blogPosts = res["results"];
      }
    }, err => {
      Log.getInstance().d(err);
    });
  }

  searchClicked(obj){
    if (obj && obj.itemType != "" && obj.query != "") {
      this.router.navigate([ "/" + Global.getCountry() + "/search", { q: encodeURIComponent(obj.query), t: obj.itemType}]);
    }
  }

  hasItems(items: any): boolean {
    if (items) {
      const keys = Object.keys(items);
      if (keys) {
        return  keys.length > 0;
      }
      return false;
    }
    return false;
  }

  getTodayDate(): string {
    const locale: string = InternationalizationHelper.getTwoCharactersLanguage();
    moment.locale(locale);
    const now: moment.Moment = moment();
    return now.format("LL");
  }

  getHome1stSubText(): string {

    let lang = InternationalizationHelper.getTwoCharactersLanguage();

    if (lang == "en") {
      return "Welcome to your one-stop shop for the best " +
        "<a href='/" + this.getCountry() + '/' + this.getString('itunesMovieDealsUrl') + "'>iTunes movie deals</a>" +
        ", Apple TV deals, iTunes sales, and price drops! Discover heavily discounted movies on Apple TV, Google Play, Amazon, and Vudu using our powerful price tracker.  Uncover amazing discounts and limited-time offers on your favorite films.";
    } else {
      return StringHelper.format(this.getString('home1stSub'),
        "<a href='/" + this.getCountry() + '/' + this.getString('itunesMovieDealsUrl') + "'>" + this.getString('itunes') + "</a>",
        "<a href='/" + this.getCountry() + '/' + this.getString('primeVideoDealsUrl') + "'>" + this.getString('amazon') + "</a>",
        "<a href='/us/" + this.getString('vuduMovieDealsUrl') + "'>" + this.getString('vudu') + "</a>",

        "<a href='/" + this.getCountry() + '/itunes/' + this.getString('moviesUrl') + '/' + this.getString('blackFridayDealsUrl') + "'>" + this.getString('itunes') + "</a>",
        "<a href='/" + this.getCountry() + '/amazon/' + this.getString('moviesUrl') + '/' + this.getString('blackFridayDealsUrl') + "'>" + this.getString('amazon') + "</a>",
        "<a href='/us/vudu/" + this.getString('moviesUrl') + '/' + this.getString('blackFridayDealsUrl') + "'>" + this.getString('vudu') + "</a>"
      );
    }
  }

  setItunesSectionStrings() {
    let lang = InternationalizationHelper.getTwoCharactersLanguage();
    let string1 = "";
    let string2 = "";

    if (lang == "en") {
      string1 = "Unlock the best " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('onSaleUrl') + "' class=\"blue-link-simple\">iTunes movie deals</a>" +
        ", saving you up to 80% on the latest blockbusters, classic favorites, and must-own collections. iTunes boasts a massive movie and TV " +
        "show library, but finding those hidden gems can be a chore. CheapCharts is your solution! Find what you want quickly with endless filtering options, including price, genre, year, and more.";
      string2 = "We track every iTunes price drop, uncovering incredible " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movie4kUrl') + "' class=\"blue-link-simple\">4K movie deals</a>" +
        ", $4.99 steals, " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movieBundlesUrl') + "' class=\"blue-link-simple\">movie bundle deals</a>" +
        ", tv boxset deals and more. Say goodbye to overpaying and hello to a library filled with incredible cinema. From Dolby Atmos-enhanced action flicks to heartwarming family films, your Apple TV deserves the best – at the best prices!";
    }

    if (lang == "de") {
      string1 = "Entdecke die besten " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('onSaleUrl') + "' class=\"blue-link-simple\">iTunes-Filmangebote</a>" +
        " und spare bis zu 80% bei aktuellen Blockbustern, Klassikern und Filmbundles. iTunes bietet ein riesiges Angebot an Filmen und TV-" +
        "Serien, aber es kann mühsam sein, die versteckten und vor allem günstigen Perlen zu finden. CheapCharts ist die Lösung! Mit Hilfe zahlreicher Filteroptionen, darunter Preis, Genre, Jahr und vieles mehr, kannst du unter Tausenden von Angeboten schnell das finden, was du suchst.";
      string2 = "Wir verfolgen jeden Preissenkung bei iTunes und finden unglaubliche " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movie4kUrl') + "' class=\"blue-link-simple\">4K-Filmangebote</a>" +
        ", Knallerangebote für 3,99 €, " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movieBundlesUrl') + "' class=\"blue-link-simple\">Filmbundles</a>" +
        ", TV-Boxset-Angebote und mehr. Hör auf Geld aus dem Fenster zu werfen und fange an bares Geld zu sparen. Von Dolby Atmos-unterstützten Actionfilmen in 4K bis hin zu herzerwärmenden Familienfilmen – dein Apple TV verdient das Beste – zum besten Preis!";
    }

    if (lang == "fr") {
      string1 = "Découvre les meilleures " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('onSaleUrl') + "' class=\"blue-link-simple\">offres de films iTunes</a>" +
        " et économise jusqu'à 80% sur les derniers blockbusters, les classiques incontournables et les collections à posséder absolument. iTunes propose une immense bibliothèque de films et d'émissions TV, mais trouver ces perles cachées peut être fastidieux. CheapCharts est ta solution ! Trouve rapidement ce que tu recherches avec de nombreuses options de filtrage, y compris par prix, genre, année et plus encore.";
      string2 = "Nous suivons chaque baisse de prix sur iTunes et découvrons des offres incroyables sur les " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movie4kUrl') + "' class=\"blue-link-simple\">films 4K</a>" +
        ", les bonnes affaires à 4,99 €, " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movieBundlesUrl') + "' class=\"blue-link-simple\">les offres groupées de films</a>" +
        ", les offres sur les coffrets TV et plus encore. Dis adieu aux prix élevés et bonjour à une bibliothèque remplie de cinéma incroyable. Des films d'action améliorés par Dolby Atmos aux films familiaux réconfortants, ton Apple TV mérite le meilleur – aux meilleurs prix !";
    }

    if (lang == "es") {
      string1 = "Desbloquea las mejores " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('onSaleUrl') + "' class=\"blue-link-simple\">ofertas de películas de iTunes</a>" +
        ", ahorrando hasta un 80% en los últimos éxitos de taquilla, clásicos favoritos y colecciones imprescindibles. iTunes cuenta con una enorme biblioteca de películas y programas de TV, pero encontrar esas joyas ocultas puede ser una tarea difícil. ¡CheapCharts es tu solución! Encuentra lo que quieres rápidamente con infinitas opciones de filtrado, incluyendo precio, género, año y más.";
      string2 = "Seguimos cada bajada de precio de iTunes, descubriendo increíbles " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movie4kUrl') + "' class=\"blue-link-simple\">ofertas de películas en 4K</a>" +
        ", gangas de $4.99, " +
        "<a href='/" + this.getCountry() + '/' + Global.ITUNES + "/" + this.getString('moviesUrl') + "/" + this.getString('movieBundlesUrl') + "' class=\"blue-link-simple\">ofertas de paquetes de películas</a>" +
        ", ofertas de boxsets de TV y más. Dile adiós a pagar de más y hola a una biblioteca llena de cine increíble. Desde películas de acción mejoradas con Dolby Atmos hasta películas familiares conmovedoras, tu Apple TV merece lo mejor, ¡a los mejores precios!";
    }

    document.getElementById("itunes-section-text-1").innerHTML = string1;
    document.getElementById("itunes-section-text-2").innerHTML = string2;
  }

  getiTunesSectionString() {
    this.setItunesSectionStrings();
  }

  getGiftCardsText() {
    document.getElementById("giftCardsText").innerHTML =
      StringHelper.format(this.getString('home4thSub'),
    "<a href='/" + this.getCountry() + '/' + this.getString('cardDealsUrl') + "'>" + this.getString("giftCardDeals") + "</a>");
  }

  setHomePageSubtitle1() {
    let mediaType = Global.getMediaType();
    if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      mediaType = Global.MOVIES;
    }
    if(mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
      mediaType = Global.MUSIC;
    }
    const mediaUrl = this.getString(mediaType + "Url");

    let supportedStores = [];
    for(let store of Object.keys(Global.supportedCountries)) {
      if(Object.keys(Global.supportedCountries[store]).includes(this.getCountry())) {
        supportedStores.push(store);
      }
    }
    const urls = [];
    for(let store of supportedStores) {
      if(store == Global.ITUNES) {
        urls.push("<b><a href='" + this.getCountry() + "/" + Global.ITUNES + "/" + mediaUrl + "/" + this.getString('onSaleUrl') + "'>" + 'Apple TV' + "</a></b>");
      }
      if(store == Global.AMAZON) {
        urls.push("<b><a href='" + this.getCountry() + "/" + Global.AMAZON + "/" + mediaUrl + "/" + this.getString('onSaleUrl') + "'>" + this.getString('amazonPrimeVideo') + "</a></b>");
      }
      if(store == Global.GOOGLEPLAY) {
        urls.push("<b><a href='" + this.getCountry() + "/google-play/" + mediaUrl + "/" + this.getString('onSaleUrl') + "'>" + this.getString('googlePlay') + "</a></b>");
      }
      if(store == Global.VUDU) {
        urls.push("<b><a href='" + this.getCountry() + "/" + Global.VUDU + "/" + mediaUrl + "/" + this.getString('onSaleUrl') + "'>" + this.getString('vudu') + "</a></b>");
      }
    }

    const text = StringHelper.format(this.getString('homePageSubtitle1_' + supportedStores.length), ...urls);

    document.getElementById('homePageSubtitle1').innerHTML = text;
  }

  showAmazon(): boolean {
    if (this.getCountry() == "us" || this.getCountry() == "de") {
      return true;
    }

    return false;
    //return Config.showAmazonUS;
  }

}
